import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation } from "react-router-dom";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persistedFlag = sessionStorage.getItem("fromMobileApp");
        if (String(persistedFlag || "").toLowerCase() === "true") {
          return true;
        }
        const persisted = JSON.parse(
          sessionStorage.getItem("userData") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;

    useEffect(() => {
      if (!fromMobileAppInUrl && !fromMobileAppInUser) return;
      try {
        sessionStorage.setItem("fromMobileApp", "true");
      } catch {
        // Ignore storage errors in restricted environments.
      }
    }, [fromMobileAppInUrl, fromMobileAppInUser]);
 

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname)) {
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])

  // Admin's "Tab Name" (Rules page, Basic Details) drives the browser tab
  // title across every player-facing page.
  useEffect(() => {
    if (themeData?.tab_name) {
      document.title = themeData.tab_name;
    }
  }, [themeData?.tab_name]);


  useEffect(() => {
    if (themeStatus !== "succeeded" || !themeData) return;

    applyCustomTheme(themeData.colors);

    const isWelcomeGame =
      /^\/welcome\/?$/.test(location.pathname) || /^\/fullhouse\/?$/.test(location.pathname);
    if (isWelcomeGame) return;

    const applyBodyBackground = () => {
      const body = document.body;
      const useGameBg =
        body.classList.contains("game-bg") ||
        location.pathname.startsWith("/game");
      const mobile = window.innerWidth <= 768;
      let bg = useGameBg
        ? mobile
          ? themeData.game_background_mob
          : themeData.game_background_desk
        : mobile
          ? themeData.background_mob
          : themeData.background_desk;
      if (useGameBg && !bg) {
        bg = mobile ? themeData.background_mob : themeData.background_desk;
      }
      const bgUrl = bg ? encodeURI(process.env.REACT_APP_S3_PATH + bg) : null;
      if (bgUrl) {
        body.style.backgroundImage = `url("${bgUrl}")`;
        body.style.backgroundSize = "100% 100%";
        body.style.backgroundRepeat = "no-repeat";
        body.style.backgroundAttachment = "fixed";
      } else {
        body.style.removeProperty("background-image");
      }
    };

    applyBodyBackground();
    window.addEventListener("resize", applyBodyBackground);
    window.addEventListener("orientationchange", applyBodyBackground);
    return () => {
      window.removeEventListener("resize", applyBodyBackground);
      window.removeEventListener("orientationchange", applyBodyBackground);
    };
  }, [themeStatus, themeData, location.pathname]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={logoUrl} className="logo-holder" /></a>
        {!isFromMobileApp && (
          <div className="back-holder">
            <a href={backUrl}><button className="back-default">Back</button></a>
          </div>
        )}
       
      </header>
      {children}
    </>
  );
}

export default USER;